import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import {
    Box,
    Stack,
    IconButton,
    Tooltip,
    Divider
} from '@mui/material';
import { isEqual } from 'lodash';

import { IoMdRefresh } from 'react-icons/io';

import { Icon as Iconify } from '@iconify/react';
import ModalPopUp from '../../commons/ModalPopup';
import { renderControls } from './utils/renderControls';
import UserService from '../../services/user.service';
import PopUpHandle from '../../commons/PopUpHandle';
import { useAppStore } from '../../store/appStore';


export default function PostedFilterSearch({ open, onClose, searchControls = [], setListData, showLoading, hideLoading }) {

    const {
        handleSubmit,
        control,
        
        watch,
        
        setValue

    } = useForm();

    const {

        setFilterPayload,
        
        setFilterControlValues,
        filterControlValues,
        setHoverFilterValues

    } = useAppStore();

    const values = watch();

    const [opene, setOpene] = useState(false);
    const [error, setError] = useState('');
    const [errorCode, setErrorCode] = useState(0);
    
    const handleClose = () => {
        setOpene(false);
    };




    useEffect(() => {

        if (!filterControlValues || !Array.isArray(filterControlValues)) {
            searchControls?.forEach((field) => setValue(field.ValueExpr, null));
            return;
        }

        // Process the payload if it's valid
        filterControlValues.forEach(({ ControlId, Values }) => {
            if (ControlId && Values) {
                setValue(ControlId, Values.length > 1 ? Values : Values[0]);
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterControlValues, open]);



    const [UserServiceInstance, setUserServiceInstance] = useState(); // NOSONAR (code needed for passing service instance to RHFAutocomplete in future)
    useEffect(() => {
        const initialize = async () => {
            const instance = await UserService;
            setUserServiceInstance(instance);
        }
        initialize();
    }, []);

/*
    function generateFilterValues(payload, originalData) {
        const result = {};

        payload.forEach(item => {
            const originalItem = originalData.find(o => o.ValueExpr === item.ControlId);
            if (originalItem) {
                const displayValues = item.Values.map(value => {
                    const defaultValue = originalItem.DefaultValues.find(d => d[originalItem.ValueExpr] === value);
                    return defaultValue ? defaultValue[originalItem.DisplayExpr] : value;
                });
                result[originalItem.LabelName] = displayValues.join(', ');
            }
        });

        return result;
    }

    old code commented
*/


    function generateFilterValues(payload, originalData) {


        const result = {};

        payload.forEach(item => {
            const originalItem = originalData.find(o => o.ValueExpr === item.ControlId);
            if (originalItem) {
                let displayValues = [];
                if (originalItem.DefaultValues && originalItem.DefaultValues.length > 0) {
                    // Process values when DefaultValues are available
                    displayValues = item.Values.map(value => {
                        const defaultValue = originalItem.DefaultValues.find(d => d[originalItem.ValueExpr] === value);
                        return defaultValue ? defaultValue[originalItem.DisplayExpr] : value;
                    });
                } else if (originalItem.DataType === 'Date') {
                    // Handle Date type control
                    displayValues = item.Values;  // Assuming the payload already has the correct date values
                } else {
                    // Handle other types where DefaultValues are not available
                    displayValues = item.Values;
                }

                result[originalItem.LabelName] = displayValues.join(', ');
            }
        });

        return result;
    }


    
    function removeSelectAllKeyValue(controls, payload) {
        const controlMap = new Map(
            controls.map(ctrl => [ctrl.ValueExpr, ctrl])
        );

        function extractValueExpr(controlId) {
            if (controlId.includes('-')) {
                const parts = controlId.split('-');
                return parts[parts.length - 1];
            }
            return controlId;
        }

        return payload.filter(entry => {
            const valueExpr = extractValueExpr(entry.ControlId);
            const ctrl = controlMap.get(valueExpr);
            if (!ctrl) return true;

            if (ctrl.DataType.toLowerCase() === "multiselectdropdown") {
                const defaultValues = ctrl.DefaultValues || [];
                if (entry.Values.length === defaultValues.length) {
                    return false;
                }
            }
            return true;
        });
    }


    const onSubmit = async (data) => {
        try {
            // Prepare payload
            showLoading();
            const payload = Object.keys(data).map(key => {
                if (data[key] === undefined || data[key] === null) return null;

                const valuess = Array.isArray(data[key]) ? data[key] : [data[key]];
                if (valuess.length === 0) return null; // Skip if the array is empty

                const quotedValues = valuess.map(value => {
                    if (typeof value === 'string' && value === "Invalid Date") {
                        const today = new Date();
                        const day = today.getDate().toString().padStart(2, '0'); // Add leading zero if necessary
                        const month = today.toLocaleString('en-US', { month: 'short' }); // Get the abbreviated month
                        const year = today.getFullYear();
                        return `${day}/${month}/${year}`;
                    }
                    return value;
                });

                return {
                    ControlId: key,
                    Values: quotedValues
                };
            }).filter(item => item !== null);





            
            setFilterPayload(payload);
            const filterValuess = generateFilterValues(payload, searchControls);
            
            
            // Call API
            const serviceInstance = await UserService;
            const finalPayload = removeSelectAllKeyValue(searchControls, payload);
            const response = await serviceInstance.GetDynamicUIData(finalPayload);
            if (isEqual(payload, [])) {
                setFilterPayload(null);
                setFilterControlValues(null);
                setHoverFilterValues(null);
            } else {
                setFilterPayload(finalPayload);
                setFilterControlValues(payload);
                setHoverFilterValues(filterValuess);
            }


            // Set data and close
            
            setListData(response.data);
            onClose();
        } catch (err) {
            console.log("err: ", err);
            if (err.response?.data?.data === null) {
               // removed commented code from here for sonar
            }

            setErrorCode(err?.response?.data?.error?.code);
            setError(err?.response?.data?.error?.message);
            setOpene(true);


            
        } finally {
            hideLoading();
        }
    };








    const handleReset = () => {
        Object.keys(values).forEach((key) => setValue(key, null)); // Clears each field one by one
        setFilterControlValues(null);
        
    };

    


    return (


        // eslint-disable-next-line react/jsx-boolean-value
        <ModalPopUp open={open} onClose={onClose} title='Filter'
        // sx={{ width: { xs: 320, sm: 520, md: 680 } }}
        >
            <form onSubmit={handleSubmit(onSubmit)}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    minHeight: 0
                }}
            >
                <Stack spacing={2} sx={{
                    pb: 1.3, pt: 0.1, display: 'flex',
                    flexDirection: 'column',
                    flexGrow: 1,
                    minHeight: 0,
                    overflow: 'hidden' // Prevent overflow in the Stack
                }}>
                    <Box
                        sx={{
                            overflow: "auto",
                            rowGap: 2,
                            columnGap: 2,
                            display: 'grid',
                            // gridTemplateColumns='repeat(4, 1fr)'
                            gridTemplateColumns: {
                                xs: '1fr',
                                sm: '1fr',
                                md: '1fr 1fr',
                                lg: '1fr 1fr ',
                                xl: '1fr 1fr 1fr'
                            },
                            gridAutoRows: 'min-content',
                            paddingTop: '0.4rem',
                            // border: '2px solid red',
                        }}
                    >
                        {searchControls?.map((field, index) => renderControls(field, index, control, null))}

                    </Box>
                    <Divider />
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Tooltip title='Reset' sx={{ bgcolor: '#fdd835', color: '#fff', borderRadius: '4px', height: "34px", width: "34px", padding: "5px" }}>
                            <IconButton onClick={handleReset}>
                                <IoMdRefresh />
                            </IconButton>
                        </Tooltip>
                        <Tooltip
                            title='Apply'
                            sx={{ bgcolor: '#43b5a2', color: '#fff', borderRadius: '4px', marginLeft: '8px', height: "34px", width: "34px", padding: "5px" }}
                        >
                            <IconButton type='submit'>
                                <Iconify icon='mdi:filter' />
                            </IconButton>
                        </Tooltip>
                    </Box>

                </Stack>
            </form>
            {opene && <PopUpHandle open={opene} handleClose={handleClose} error={error} errorCode={errorCode} />}
        </ModalPopUp>

    );

}

PostedFilterSearch.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    searchControls: PropTypes.arrayOf(
        PropTypes.shape({
            LabelName: PropTypes.string.isRequired,
            DataType: PropTypes.string.isRequired,
            DefaultValues: PropTypes.array,
            ValueExpr: PropTypes.string,
            DisplayExpr: PropTypes.string,
        })
    ).isRequired,
    setListData: PropTypes.func,
    showLoading: PropTypes.func,
    hideLoading: PropTypes.func,

};